import React from "react";
import { Path, Svg, Text } from "react-native-svg";
export var describePie = function (x, y, radius, startAngle, endAngle, padding, spaces) {
    if (!padding) {
        padding = 0.01;
    }
    var space = radius - (radius - (padding * padding));
    var start = polarToCartesian(x, y, radius, endAngle - padding);
    var end = polarToCartesian(x, y, radius, startAngle + (padding / 2));
    var startCenter = polarToCartesian(x, y, space, endAngle - ((padding)));
    var endCenter = polarToCartesian(x, y, space, startAngle + ((padding) / padding));
    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    var d = [
        "M", start.x, start.y,
        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y,
        "L", endCenter.x, endCenter.y,
        "A", space, space, 0, 0, 1, startCenter.x, startCenter.y,
        "L", start.x, start.y,
    ].join(" ");
    return d;
};
export var polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
    };
};
export default (function (props) {
    var _a = props.viewBox, width = _a.width, height = _a.height, x = _a.x, y = _a.y;
    // let newViewBox = { width: width , height: height , x: x, y: y }
    var w = Math.min(width, height);
    var radio = w / 2;
    var center = w / 2;
    var padding = (360 / props.frecuencyTable.intervals.length) * (props.space * 0.5);
    var render_circles = function () {
        // if (!this.props.data) return null;
        // var arr = Func.simplifyObjectValue(this.props.data);
        // const sum = Func.sum(arr)
        var currentAngle = 0;
        return props.frecuencyTable.intervals.map(function (label, index) {
            var _a;
            // if (!obj.color) obj.color = Func.color_random();
            var angle = 0;
            var fy = props.frecuencyTable.relative_frequency[index];
            // if (typeof obj.val == "number") {
            angle = ((fy * 100) / 100) * 360;
            // } else {
            // if (index > -1) {
            //     // fy = props.frecuencyTable.relative_frequency_scaled[indexAux]
            //     padding = 0;
            // }
            // }
            var ptext = polarToCartesian(center, center, radio * 0.75, currentAngle + (angle / 2));
            var p = React.createElement(Path, { d: describePie(center, center, radio, currentAngle, currentAngle + angle, padding, 0), strokeWidth: props.strokeWidth, stroke: props.frecuencyTable.intervals_color[index], fill: props.frecuencyTable.intervals_color[index] + "22" });
            currentAngle += angle;
            return React.createElement(React.Fragment, null,
                p,
                React.createElement(Text, { dx: ptext.x, dy: ptext.y, textAnchor: "middle", fill: (_a = props.textColor) !== null && _a !== void 0 ? _a : "#000", fontSize: 10, translateY: 0 },
                    (Math.round(100 * fy)),
                    "%"));
        });
    };
    return React.createElement(Svg, { height: "100%", width: "100%", viewBox: "0 0 ".concat(width, " ").concat(height) }, render_circles());
});
